import React, {Fragment, useState} from 'react'
import SchemaProduct from './SchemaProduct';
import SchemaRecipe from './SchemaRecipe';
import SchemaFarmshopProducts from './SchemaFarmshopProducts';
import SchemaBlog from './SchemaBlog';
import SchemaMeatcut from './SchemaMeatcut';
import {currentLang} from './../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import truncate from 'lodash/truncate';
import { useTranslation } from 'react-i18next';
import flatstore from 'flatstore';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';


const Meta = ({type, title, description, robots, url, site_name, fbadmins, image, card, type_data, statusCode}) => {
    const { t } = useTranslation();
    var {pathname} = useLocation();
    var canonicalurl = window.location.origin+window.location.pathname.replace(/\/$/, "");

    const is_homepage = pathname == '/'+currentLang() && pathname !== '/'+currentLang()+'/';

    // remove animal from urls
    var animalIndex = canonicalurl.indexOf('/'+t('menu.animal'));
    if(animalIndex > 1){
        canonicalurl = canonicalurl.substr(0, animalIndex);
    }
    var page_canonical = flatstore.get('canonical_url');
    if(page_canonical)
        canonicalurl = window.location.origin+page_canonical;

    // remove html from description
    description = description ? description.replace(/<[^>]+>/g, '') : "";
    // truncate on a word boundary (~160 chars) so descriptions never cut mid-word
    const metaDescription = truncate(description, {'length': 160, 'separator': ' '});
    // og/twitter image: the page's own image when provided, else the per-brand
    // default share image (1200x630) served from public/ on both domains
    const shareImage = image
        ? image
        : window.location.origin + (currentLang() === 'de' ? '/og-kaufnekuh.jpg' : '/og-grutto.jpg');
    // Only declare og:image dimensions for the default share image, whose size we
    // know (both brand files are exactly 1200x630). A page-supplied `image` has
    // arbitrary dimensions, and publishing wrong ones is worse than none: social
    // crawlers use them to lay the card out before fetching, so a mismatch renders
    // a cropped or letterboxed preview.
    const usingDefaultShareImage = !image;

    return (
        <Fragment>
            <Helmet defer={true}>
                <title>{title+" | "+siteInfo[currentLang()]['title']}</title>
                {statusCode && <meta name="prerender-status-code" content={String(statusCode)} />}
                {is_homepage && <link rel="alternate" href="https://www.grutto.com/global/" hreflang="x-default"></link>}
                {is_homepage && <link rel="alternate" href="https://www.grutto.com/nl" hreflang="nl-nl"></link>}
                {is_homepage && <link rel="alternate" href="https://www.grutto.com/fr" hreflang="fr-fr"></link>}
                {is_homepage && <link rel="alternate" href="https://www.grutto.com/uk" hreflang="en-gb"></link>}
                {is_homepage && <link rel="alternate" href="https://www.kaufnekuh.de/de" hreflang="de-de"></link>}
                <link rel="canonical" href={canonicalurl.toLowerCase()} ></link>
                <meta name="description" content={metaDescription}/>
                {robots && <meta name="robots" content={robots} />}
                <meta property="og:locale" content={siteInfo[currentLang()]['locale']} />
                <meta property="og:type" content={type ? type : "website"} />
                <meta property="og:title" content={title+" "+siteInfo[currentLang()]['title']+"!"}/>
                <meta property="og:description" content={metaDescription}/>
                <meta property="og:url" content={canonicalurl.toLowerCase()}/>
                <meta property="og:site_name" content={siteInfo[currentLang()]['domain']}/>
                <meta property="fb:admins" content={siteInfo[currentLang()]['fbadmins']} />
                <meta property="og:image" content={shareImage}/>
                {usingDefaultShareImage && <meta property="og:image:width" content="1200" />}
                {usingDefaultShareImage && <meta property="og:image:height" content="630" />}
                <meta name="twitter:card" content={card ? card : "summary_large_image"} />
                <meta name="twitter:description" content={metaDescription}/>
                <meta name="twitter:title" content={siteInfo[currentLang()]['twtitle']+" "+title}/>
                <meta name="twitter:site" content={siteInfo[currentLang()]['twitter']} />
                <meta name="twitter:image" content={shareImage}/>
            </Helmet>

            {type == "product" &&
                <SchemaProduct data={type_data} />
            }
            {type == "recipe" &&
                <SchemaRecipe data={type_data} />
            }
            {type == "farmshop" &&
                <SchemaFarmshopProducts data={type_data} />
            }
            {type == "blog" &&
                <SchemaBlog data={type_data} />
            }
            {type == "meatcut" &&
                <SchemaMeatcut data={type_data} />
            }
        </Fragment>
    )
}

export default Meta
